// extracted by mini-css-extract-plugin
export var carrierIcon = "_yn-0";
export var carrierLogo = "_yn-1";
export var detailsSection = "_yn-2";